export const FEATURE_FLAGS = {
  compliance: 'COMPLIANCE',
  unreadPosts: 'UNREAD_POSTS',
  userSubscriptions: 'USER_SUBSCRIPTIONS',
  commenting: 'COMMENTING',
  globalNav: 'GLOBAL_NAV',
  classificationSchemas: 'CLASSIFICATION_SCHEMAS',
  createStudies: 'CREATE_STUDIES',
  publishContent: 'PUBLISH_CONTENT',
  studyMemberDirectoryActions: 'STUDY_MEMBER_DIRECTORY_ACTIONS',
  teamsAndMembershipManagementActions: 'TEAMS_AND_MEMBERSHIP_MGMT_ACTIONS',
  dashboardGroupStudiesByStudyStatusOption:
    'DASHBOARD_GROUP_STUDIES_BY_STUDY_STATUS_OPTION',
  userProfileResetPassword: 'USER_PROFILE_RESET_PASSWORD',
  editStudyNameOnStudyAdmin: 'EDIT_STUDY_NAME_ON_STUDY_ADMIN',
  requireTermsOfService: 'REQUIRE_TERMS_OF_SERVICE',
  showUserRolesColumn: 'SHOW_USER_ROLES_COLUMN',
  showStudySiteDatesOfRecord: 'SHOW_STUDY_SITE_DATES_OF_RECORD',
  exchangeAndPickupPackagingServiceItemsInTimelineResults:
    'EXCHANGE_AND_PICKUP_PACKAGING_SERVICE_ITEMS_IN_TIMELINE_RESULTS',
  showSharingSectionOnTimelineDetailPages:
    'SHOW_SHARING_SECTION_ON_TIMELINE_DETAIL_PAGES',
  showOversightAssignmentsSectionOnSitesDetailPages:
    'SHOW_OVERSIGHT_ASSIGNMENTS_SECTION_ON_SITES_DETAIL_PAGES',
  fullWidthRemarksTitle: 'FULL_WIDTH_REMARKS_TITLE',
  newStudyReportsDto: 'EEC_2265_NEW_STUDY_REPORTS_DTO',
  dataNormalizationInterceptor: 'EEC_2281_DATA_NORMALIZATION_INTERCEPTOR',
  recordReportDownloadActivity: 'WIP_RECORD_REPORT_DOWNLOAD_ACTIVITY',
  studyReportViews: 'WIP_STUDY_REPORT_VIEWS',
  studySalesReport: 'EEC_2091_STUDY_SALES_REPORT',
  studyRentalsReport: 'EEC_2092_STUDY_RENTALS_REPORT',
  studyRentedProductsReport: 'EEC_2093_STUDY_RENTED_PRODUCTS_REPORT',
  studyInvoiceChargesReport: 'EEC_2094_STUDY_INVOICE_CHARGES_REPORT',
  studyPickupsReport: 'EEC_2095_STUDY_PICKUPS_REPORT',
  studyBurnRate: 'EEC_2323_BURN_RATE_I',
  legacyStudyReports: 'EEC_2945_LEGACY_STUDY_REPORTS',
  studyContactRefactor: 'EEC_2460_STUDY_CONTACT_REFACTOR',
  tmaasPageAccess: 'EEC_2559_TMAAS_PAGE_ACCESS',
} as const;

export type Flags = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
